import OrgAdminTaskDashboard from './OrgAdminTaskDashboard';

// The org-admin task detail is now the redesigned Task Detail Dashboard.
// The shared, user-facing TaskDetail (pages/TaskDetail.jsx) is left as-is
// and still serves the user portal at /tasks/:id.
function OrgAdminTaskDetail() {
  return <OrgAdminTaskDashboard />;
}

export default OrgAdminTaskDetail;
